var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 44,
    viewBox: "0 0 67 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment logos/elo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.12582,
    y: 0.843713,
    width: 65.3279,
    height: 42.1974,
    rx: 7.65805,
    fill: "#020A23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.12582,
    y: 0.843713,
    width: 65.3279,
    height: 42.1974,
    rx: 7.65805,
    stroke: "#A5B9D8",
    strokeWidth: 0.312574
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4153 17.5182C18.9068 17.3541 19.4321 17.2658 19.9791 17.2658C22.3641 17.2658 24.3549 18.9597 24.8115 21.2117L28.1922 20.5218C27.4159 16.6956 24.0345 13.8157 19.9791 13.8157C19.0497 13.8157 18.1572 13.9671 17.322 14.2461L18.4153 17.5182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4256 28.475L16.7117 25.8902C15.6914 24.986 15.0474 23.6666 15.0474 22.1965C15.0474 20.7276 15.6905 19.4087 16.7102 18.5057L14.4236 15.9206C12.6907 17.4559 11.597 19.699 11.597 22.1965C11.597 24.6957 12.6912 26.9393 14.4256 28.475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.81 23.1853C24.3516 25.4359 22.3623 27.1267 19.9785 27.1267C19.4314 27.1267 18.9045 27.0385 18.4136 26.8734L17.3184 30.1465C18.1536 30.4255 19.0482 30.5764 19.9785 30.5764C24.03 30.5764 27.4112 27.7013 28.1902 23.8786L24.81 23.1853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9035 24.9794C37.9025 24.9802 37.9015 24.981 37.9009 24.9822L37.8048 24.9173C37.528 25.3665 37.0957 25.7305 36.5507 25.9669C35.5133 26.418 34.5521 26.3019 33.8616 25.6966L33.7983 25.7931C33.7976 25.792 33.7973 25.7912 33.7963 25.7912L32.6192 27.5522C32.9112 27.7553 33.2253 27.9273 33.5546 28.0649C34.8551 28.605 36.186 28.5802 37.4966 28.0099C38.4446 27.5994 39.1888 26.9726 39.6972 26.1785L37.9035 24.9794ZM34.2285 20.6341C33.1331 21.1049 32.5683 22.1322 32.6845 23.3373L37.3248 21.3403C36.5269 20.4026 35.4885 20.0916 34.2285 20.6341ZM31.1477 25.999C31.037 25.8195 30.8861 25.5327 30.7959 25.3214C30.2604 24.0787 30.2346 22.7923 30.6867 21.5576C31.1838 20.2035 32.1336 19.1668 33.3604 18.6388C34.9028 17.9751 36.6089 18.106 38.0872 18.9831C39.0267 19.5218 39.6923 20.3538 40.1977 21.53C40.2623 21.6808 40.319 21.8415 40.3742 21.9782L31.1477 25.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5997 16.0448V25.8363L45.1224 26.4534L44.2574 28.4718L42.5773 27.7719C42.2 27.6086 41.9431 27.3588 41.7488 27.0766C41.5627 26.7891 41.4239 26.3943 41.4239 25.8632V16.0448H43.5997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5429 23.3423C47.5436 22.5085 47.9118 21.7611 48.4945 21.2526L46.9327 19.5114C45.8738 20.4474 45.2065 21.8157 45.2052 23.3396C45.2033 24.8647 45.8698 26.2345 46.9278 27.173L48.4877 25.4301C47.908 24.9195 47.5426 24.174 47.5429 23.3423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3176 26.1207C50.0101 26.1199 49.7141 26.069 49.4376 25.977L48.6919 28.1948C49.2016 28.3659 49.7478 28.4591 50.3151 28.46C52.788 28.4624 54.8531 26.7077 55.3315 24.3752L53.0392 23.907C52.778 25.1717 51.6586 26.1217 50.3176 26.1207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3248 18.2288C49.7579 18.2282 49.2122 18.3205 48.7033 18.49L49.4423 20.7096C49.7194 20.6179 50.0156 20.5675 50.3225 20.5675C51.6668 20.5688 52.7872 21.5247 53.0416 22.7925L55.3346 22.3273C54.8628 19.9917 52.7995 18.2303 50.3248 18.2288Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElo);
export default __webpack_public_path__ + "static/media/elo.1337b61502ed8b692b3a28d0a0aff1e2.svg";
export { ForwardRef as ReactComponent };